import React from 'react';

const StatCard = ({ title, value, icon: Icon, color = '#3b82f6' }) => {
  return (
    <div className="stat-card">
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '16px',
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: `${color}20`,
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <Icon size={24} color={color} />
        </div>
      </div>
      <div className="stat-number" style={{ color }}>
        {value?.toLocaleString() || 0}
      </div>
      <div className="stat-label">{title}</div>
    </div>
  );
};

export default StatCard;
